import React from 'react';
import VASLoading from "../../../../../assets/booking/Vas-Loading_1.gif";

export default function Loading() {
    return (<div><img src={VASLoading}></img> </div>);
}